import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ListBasketItems from "./ListBasketItems"
import classNames from 'classnames'
import showBasketStatus from "../../../vietnamese/showBasketStatus"
import showLocationType from "../../../vietnamese/showLocationType"
import ReleaseBasketButton from "../actions/ReleaseBasketButton"
import ExportQrCode from "../actions/ExportQRCode"
import { Button, message, Select } from 'antd'
import { CheckCircleFill } from "@ant-design/icons"
import { deleteBasketPosition, updateBasketPosition } from '../../../services/api/mergerApi'
import { getDetailBarcode } from '../../../services/api/3dApi'
import { Icon, Modal } from 'antd'
import _ from "lodash"

const { Option } = Select;
class BasketDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            saving: false,
            deleting: false,
            isEditPosition: false,
            positionEdit: this.props.result.position ? this.props.result.position : '',
            orderData : {},
            image: '',
            isOpenPreview: false,
        }
        this.getDataTimeout = null
    }
    
    fetchOrderData = async (barcode) => {
        try {
            const { data: response } = await getDetailBarcode(barcode)
            const { data, success, error } = response
            if (!success) {
                throw new Error(error)
            }
            this.setState({
                orderData: data
            })
        } catch (error) {
            console.log('error', error)
        }
    }

    
    componentDidMount() {
        const { result } = this.props
        const { items = [], order_number = '' } = result || {}
        const itemhasOrderData = items.find(i => !!i.orderData)
        const { orderData = {} } = itemhasOrderData || {}
        if (!!itemhasOrderData) {
            this.setState({
                orderData: orderData
            })
            return
        }
        this.fetchOrderData(`${order_number}_1`)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.result !== this.props.result) {
            const { result } = this.props
            const { items = [], order_number = '' } = result || {}
            const itemhasOrderData = items.find(i => !!i.orderData)
            const { orderData = {} } = itemhasOrderData || {}
            if (!!itemhasOrderData) {
                this.setState({
                    orderData: orderData
                })
                return
            }
            this.fetchOrderData(`${order_number}_1`)
        }
    }

    _handleClickEditPosition = () => {
        // const {result} = this.props
        // const {position} = result

        this.setState({
            isEditPosition: true,
            // positionEdit: position ? position : ''
        })
    }

    _handleCancelEditPosition = () => {
        this.setState({
            isEditPosition: false,
            // positionEdit: ''
        })
    }

    _handleResetPosition = () => {
        this.setState({
            isEditPosition: false,
            positionEdit: ''
        })
    }

    _handleChangePosition = (value) => {
        this.setState({
            positionEdit: value
        })
        clearTimeout(this.getDataTimeout)
        this.getDataTimeout = setTimeout(value ? this._handleAutoSavePositon : this._handleAutoDeletePositon, 1000)
    }

    _handleAutoSavePositon = async () => {
        const { positionEdit } = this.state
        const { result } = this.props
        const { _id } = result

        this.setState({
            saving: true
        })

        try {
            const { data } = await updateBasketPosition(_id, { position: positionEdit })
            const { success, error } = data
            if (success) {
                this.setState({
                    saving: false
                })
                message.success("Update position is success!")
            } else {
                this.setState({
                    saving: false
                })
                message.error(error)
            }
        } catch (error) {
            this.setState({
                saving: false
            })
            message.error(error)
        }

        this.setState({
            isEditPosition: false,
            // positionEdit: ''
        })
    }

    _handleAutoDeletePositon = async () => {
        const { result } = this.props
        const { _id } = result

        this.setState({
            deleting: true
        })

        try {
            const { data } = await deleteBasketPosition(_id)
            const { success, error } = data
            if (success) {
                this.setState({
                    deleting: false
                })
                message.success("Delete position is success!")
            } else {
                this.setState({
                    deleting: false
                })
                message.error(error)
            }
        } catch (error) {
            this.setState({
                deleting: false
            })
            message.error(error)
        }

        this.setState({
            isEditPosition: false,
            positionEdit: ''
        })
    }

    _onFieldClear = () => {
        console.log("reload page or do something...")
    }

    renderTypeBasket = (type = '') => {
        switch (type) {
            case 'normal':
                return 'Đơn thường'
            case 'combo_fac':
                return 'Combo FAC'
            case 'combine_ship':
                return 'Gộp ship'
            default:
                return ''
        }
    }

    _handleChangeImage = (url = '', open = false) => {
        this.setState(preState => ({
            ...preState,
            image: url,
            isOpenPreview: open
        }))
    }
    render() {
        const {isEditPosition, positionEdit, saving, deleting} = this.state
        const { result, disabledCheckExists, showImage, isAppliedBrandingForAllItems } = this.props
        const { completed_items, exists, items = [], number, location, order_number, status, total_items, order_numbers = [], type = '', barcode = {} } = result || {}
        const {tags = []} = barcode
        const tagsRule = _.get(this.state.orderData, 'meta.brand.rule.tags') || []
        const imagePackaging = tagsRule.filter(i => _.get(i, "type") === "packaging") || []
        const isShowImagePackaging = !!imagePackaging.length && _.get(this.state.orderData, 'meta.brand.rule.brand.name') === "ZENITH"
        const vItems = Array.isArray(items) ? items : []
        const action = exists ? 'Đã có giỏ' : 'Giỏ mới'
        const badge = exists ? 'badge-success' : 'badge-info'
        const allItemsCompleted = vItems.every(i => i.status === 'completed')
        const filterItems = vItems.filter(i => i.product_type === "THANK_CARD" || i.product_type === 'BRAND_KIT') || []
        const showImg = !!showImage && !!allItemsCompleted && !!filterItems.length
        const imgLink = _.get(filterItems[0], "orderData.design_front") || _.get(filterItems[0], "orderData.preview_image") || ''
        const brandingItems = filterItems.length && filterItems.reduce((mem, item) => {
            return {
                ...mem,
                [item.product_type]: mem[item.product_type] ? mem[item.product_type] + 1 : 1
            }
        }, {})

        const optionsPostion = []
        for (let i = 1; i < 101; i++) {
            optionsPostion.push({
                value: i.toString(),
                label: i.toString(),
            })
        }
        
        const { orderData = {} } = this.state
        const { tags: orderTags = [] } = orderData || {}
        const isMadeInVN = orderTags.includes('made_vn')
        const isPhotoRequest = tags.includes('photo_requested')

        return (
            <div className={classNames("BasketDetail", { exists: !!exists }, status, location)}>
                <div className="Huge">
                    {
                        isAppliedBrandingForAllItems &&
                        <p className="alert alert-danger">BrandKit theo item</p>
                    }
                    <div className={`BasketInfo ${(!!showImg || isShowImagePackaging) ? 'row' : ''} `}>
                        <div className={`InfoRight ${!!showImg ? 'col-6' : isShowImagePackaging ? 'col-8' : ''}`}>
                            <div className="row mb-3">
                                <div className="col-6 text-right">Số giỏ</div>
                                <div className="col-6">
                                    <h4>
                                        <span className="BasketNumber">{number}</span>
                                        <span className="TotalItems">/{total_items}</span>
                                        {
                                            !disabledCheckExists &&
                                            <span className={classNames("Action ml-5 badge", badge)}>{action}</span>
                                        }
                                    </h4>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-6 text-right">Hoàn thành</div>
                                <div className="col-6"><h4>{completed_items} / {total_items}</h4></div>
                            </div>

                            <div className="row mb-3 row-order-number">
                                <div className="col-6 text-right">Số đơn</div>
                                <div className="col-6">
                                    <h4>
                                        {
                                            !!order_numbers.length ?
                                                order_numbers.map(i => `#${i}`).join(', ') :
                                                `#${order_number}`
                                        }
                                        {
                                            !!brandingItems && <div className="branding-count">
                                                {
                                                    Object.keys(brandingItems).map((type, index) => {
                                                        return <span className={`branding-${type}`} key={index}>
                                                            <strong className="badge badge-danger">{brandingItems[type]}</strong>
                                                            <span>{type}</span>
                                                        </span>
                                                        {/*{*/ }
                                                        {/*    index < Object.keys(brandingItems).length - 1 &&*/ }
                                                        {/*    <span className="separator">|</span>*/ }
                                                        {/*}*/ }
                                                    })
                                                }
                                            </div>
                                        }
                                    </h4>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-6 text-right">Địa chỉ</div>
                                <div className="col-6"><h4>{showLocationType(location)}</h4></div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-6 text-right">Trạng thái</div>
                                <div className="col-6">
                                    <h4>{showBasketStatus(status)}</h4>
                                    <div className="Tags">
                                        {isMadeInVN &&
                                            <span className="tagVN mr-2 mb-2">Made in VN</span>
                                        }
                                        {
                                            isPhotoRequest &&
                                            <span className="photo_request mr-2 mb-2">CHỤP ẢNH</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                !!type &&
                                <div className="row mb-3">
                                    <div className="col-6 text-right">Loại giỏ</div>
                                    <div className="col-6">
                                        <h4>{this.renderTypeBasket(type)}</h4>
                                    </div>
                                </div>
                            }

                            <div className="row mb-3">
                                <div className="col-6 text-right">Vị trí</div>
                                <div className="col-6 d-flex align-items-center">
                                    {
                                        isEditPosition ? <Select
                                            showSearch
                                            allowClear
                                            placeholder=""
                                            style={{ width: 70, marginRight: '10px' }}
                                            onChange={this._handleChangePosition}
                                            value={positionEdit || undefined}
                                        >
                                            {optionsPostion.map(option => (
                                                <Option key={option.value}>{option.label}</Option>
                                            ))}
                                        </Select> :
                                            <h4 style={{ margin: '0 10px 0 0' }}>
                                                {
                                                    positionEdit ? positionEdit : '--'
                                                }
                                            </h4>
                                    }

                                    <Button type="primary" onClick={isEditPosition ? this._handleCancelEditPosition : this._handleClickEditPosition} disabled={saving || deleting ? true : false}>{isEditPosition ? saving ? 'Saving...' : deleting ? 'Deleting...' : 'Cancel' : 'Edit'}</Button>
                                </div>
                            </div>
                        </div>
                        {!!showImg &&
                            <div className={`InfoLef ${isShowImagePackaging ? "col-4" : "col-6"} mb-3 d-flex justify-content-center align-items-start`}>
                                {!!imgLink ?
                                    <img src={imgLink} style={{ maxHeight: '500px' }} alt='preview' /> :
                                    <h6>Sản phẩm {filterItems[0].product_type} không có hình ảnh</h6>
                                }
                            </div>
                        }
                        {
                            isShowImagePackaging &&
                            <div className="show-image-packaging">
                                {
                                    imagePackaging.map((o, index) => (
                                        <div className='position-relative' key={index}>
                                            <img 
                                                src={_.get(o, 'design')} 
                                                style={{ maxWidth: '300px', marginBottom: 10, cursor: 'pointer' }} 
                                                loading='lazy' 
                                                alt='preview'
                                                onClick={() => this._handleChangeImage(_.get(o, 'design'), true)}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        }
                        {
                            !!this.state.image && this.state.isOpenPreview &&
                            <Modal
                                visible={this.state.isOpenPreview}
                                onCancel={() => this._handleChangeImage('', false)}
                                closable={false}
                                footer={false}
                                width={"50vw"}
                                height={"75vh"}
                            >
                                <img
                                    src={this.state.image}
                                    alt="preview"
                                    width={"100%"}
                                    style={{ objectFit: 'contain' }}
                                />
                            </Modal>
                        }
                    </div >
                    <div className="ActionBatches col-12 mb-3">
                        <ReleaseBasketButton onClose={this.props.onClose} basket={result} resetPosition={this._handleResetPosition} />
                        <ExportQrCode items={items} basket={number} totalItems={total_items} className='ml-3' />
                    </div>
                    <ListBasketItems items={vItems} type={type} />
                </div >
            </div >
        )
    }
}

BasketDetail.propTypes = {
    disabledCheckExists: PropTypes.bool,
    result: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default BasketDetail
